'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TracksCount.scss');

var TracksCount = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TracksCount, _Component);

  function TracksCount() {
    (0, _classCallCheck3.default)(this, TracksCount);
    return (0, _possibleConstructorReturn3.default)(this, (TracksCount.__proto__ || (0, _getPrototypeOf2.default)(TracksCount)).apply(this, arguments));
  }

  (0, _createClass3.default)(TracksCount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          count = _props.count;


      return _react2.default.createElement(_reactI18next.Interpolate, {
        className: (0, _bind2.default)(styles.count, className),
        i18nKey: '{{tracksCount}} tracks',
        tracksCount: count
      });
    }
  }]);
  return TracksCount;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  count: _propTypes2.default.number
}, _class.defaultProps = {
  count: 0
}, _temp);
exports.default = TracksCount;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TracksCount/TracksCount.js
// module id = 858
// module chunks = 1